'use strict';

const _=require('pulsar-utils/dist-es6/_');

function hasPixels(dimension){
return dimension.match(/px$/);
}let

BaseResizableDirectiveController=class BaseResizableDirectiveController{
constructor($scope,$element,$window){
this._$scope=$scope;
this._$element=$element;
this._$window=$window;
this.dimensions={};
this.axisLabelMargins=this.axisLabelMargins||{left:0,right:0,top:0,bottom:0};
this._lastValidWidth=null;
this._lastValidHeight=null;

$scope.$watch('controller.dimensions',(n,o)=>{
if(!_.exists(n)||n===o){
return;
}

$scope.$evalAsync(()=>{
this._onDimensionsChanged(n,o);
});
},!0);
$scope.$on('resize::resize',()=>this._tryToUpdateDimensions());

this._tryToUpdateDimensions();
}

_tryToUpdateDimensions(){
this._$scope.$evalAsync(()=>{
const computedStyle=this._$window.getComputedStyle(this._$element[0]);
const computedWidth=computedStyle.width;
const computedHeight=computedStyle.height;

if(hasPixels(computedWidth)&&hasPixels(computedHeight)){
const width=parseInt(computedWidth,10);
const height=parseInt(computedHeight,10);

if(this._lastValidHeight===height&&this._lastValidWidth===width&&
width-this.axisLabelMargins.left-this.axisLabelMargins.right>0&&
height-this.axisLabelMargins.top-this.axisLabelMargins.bottom>0){
this.dimensions={
width:width,
height:height};

return;
}

this._lastValidHeight=height;
this._lastValidWidth=width;
}

this._tryToUpdateDimensions();
});
}

get _dimensionsValid(){
return _.exists(this.dimensions)&&_.exists(this.dimensions.width)&&_.exists(this.dimensions.height);
}

_onDimensionsChanged(newDimensions,oldDimensions){

}};


module.exports=BaseResizableDirectiveController;
//# sourceMappingURL=baseResizableDirectiveController.js.map
